/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectCostTypeFromJSON, ProjectCostTypeToJSON, } from './ProjectCostType';
/**
 * Check if a given object implements the ProjectType interface.
 */
export function instanceOfProjectType(value) {
    return true;
}
export function ProjectTypeFromJSON(json) {
    return ProjectTypeFromJSONTyped(json, false);
}
export function ProjectTypeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'value': json['value'] == null ? undefined : json['value'],
        'projectCostTypes': json['projectCostTypes'] == null ? undefined : (json['projectCostTypes'].map(ProjectCostTypeFromJSON)),
    };
}
export function ProjectTypeToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'value': value['value'],
        'projectCostTypes': value['projectCostTypes'] == null ? undefined : (value['projectCostTypes'].map(ProjectCostTypeToJSON)),
    };
}
